import { z } from 'zod';
import { cardStateUnorderedSchema } from './CardState.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from './PartialStrictObjectSchema.ts';
import { validateState } from './ValidateState.ts';
export const bankStateSchema = z.object({
    hideBankCards: z.boolean().readonly(),
    resourceCards: cardStateUnorderedSchema.readonly()
}).strict();
export function validateBankState(data) {
    return validateState(bankStateSchema, data);
}
export const bankStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(bankStateSchema);
